import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

export function usePreviewModeSearchParam(): [boolean, (on: boolean) => void] {
  const location = useLocation()
  const navigate = useNavigate()
  const on = new URLSearchParams(location.search).get('preview') === 'true'
  const setOn = useCallback(
    (nextOn: boolean): void => {
      const searchParams = new URLSearchParams(location.search)
      if (nextOn) searchParams.set('preview', 'true')
      else searchParams.delete('preview')
      navigate(
        {
          pathname: location.pathname,
          search: searchParams.toString(),
          hash: location.hash,
        },
        { replace: true, state: location.state },
      )
    },
    [location, navigate],
  )
  return [on, setOn]
}
